<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col-md-12">
        <div class="upload-area"></div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <form class="mt-4" @submit.prevent="update">
          <div class="form-group row">
            <label for="files" class="col-sm-2 col-form-label">Files</label>
            <div class="col-sm-10">
              <input
                type="file"
                class="form-control"
                id="files"
                placeholder="Tenant name"
                @change="handleFileChange"
                multiple
              />

              <span class="d-block invalid-feedback">{{ errors && errors.file }}</span>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-12">
              <button
                type="submit"
                class="btn btn-primary float-right"
                @click.prevent="submit"
              >
                Upload
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      errors: {},
      files: [],
    };
  },
  methods: {
    handleFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.files = files;
      this.errors = {};
    },

    submit(e) {

      if(!this.files || !this.files.length) {
          this.errors['file'] = 'Please select a file'
          return false;
      }

      this.$emit("submitted", this.files);

      this.files = [];
      $('#files').val([])
    },
  },
};
</script>